import { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Shield } from "lucide-react";

const T = {
  de: { text: "Diese Website verwendet optionale Analyse-Cookies nur mit Ihrer Zustimmung.", accept: "Akzeptieren", decline: "Ablehnen" },
  en: { text: "This website uses cookies to provide you with the best experience.", accept: "Accept", decline: "Decline" },
  fr: { text: "Ce site utilise des cookies pour vous offrir la meilleure experience.", accept: "Accepter", decline: "Refuser" },
  it: { text: "Questo sito utilizza cookie per offrirti la migliore esperienza.", accept: "Accetta", decline: "Rifiuta" },
  zh: { text: "本網站使用 Cookie，為您提供最佳瀏覽體驗。", accept: "接受", decline: "拒絕" },
};

export default function CookieBanner() {
  const { lang } = useLanguage();
  const [show, setShow] = useState(false);
  const t = T[lang] || T.de;

  useEffect(() => {
    const consent = localStorage.getItem("hk_cookie_consent");
    if (!consent) setShow(true);
  }, []);

  const handle = (v) => {
    localStorage.setItem("hk_cookie_consent", v);
    if (v === "accepted") window.dispatchEvent(new Event("hk-analytics-consent"));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-[var(--ink-deep)] border-t border-[rgba(212,161,74,0.2)] px-6 py-4 animate-in slide-in-from-bottom duration-500" role="dialog" aria-modal="true" aria-label="Cookie-Einstellungen" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Shield aria-hidden="true" size={16} className="text-[var(--gold)] flex-shrink-0" />
          <p className="text-[var(--paper-soft)] text-xs">{t.text}</p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button onClick={() => handle("declined")} className="min-h-11 text-[var(--paper-soft)] text-[14px] uppercase tracking-[0.15em] px-4 py-2 border border-[var(--paper-ghost)] hover:border-[var(--paper-soft)] transition-colors" data-testid="cookie-decline">{t.decline}</button>
          <button onClick={() => handle("accepted")} className="min-h-11 bg-[var(--gold)] text-[var(--paper)] text-[14px] uppercase tracking-[0.15em] px-4 py-2 font-medium hover:bg-[var(--gold-bright)] transition-colors" data-testid="cookie-accept">{t.accept}</button>
        </div>
      </div>
    </div>
  );
}
